// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heading[data-v-49657cf8]{line-height:1}.width-half[data-v-49657cf8]{width:50%}input[type=file][data-v-49657cf8]{border:none;background-color:inherit}", ""]);
// Exports
module.exports = exports;
